<template>
    <div class="marketList">
        <el-breadcrumb class="bread-nav" separator="/">
            <el-breadcrumb-item>首页</el-breadcrumb-item>
            <el-breadcrumb-item>市场专题</el-breadcrumb-item>
            <el-breadcrumb-item>查询专题</el-breadcrumb-item>
        </el-breadcrumb>
        <el-table class="market-list-table" :data="specialList" stripe border>
            <el-table-column prop="specialId" label="专题ID" align='center' width="80">
            </el-table-column>
            <el-table-column prop="specialName" label="专题名称" align='center' width="250">
            </el-table-column>
            <el-table-column label="专题链接" align='center'>
                <template scope="scope">
                    <a target="_blank" style="margin-left: 10px" :href="baseUrl + scope.row.specialId">{{baseUrl + scope.row.specialId}}</a>
                </template>
            </el-table-column>
            <el-table-column prop="userName" label="创建者" align='center' width="120">
            </el-table-column>
            <el-table-column label="操作" align='center' width="300">
                <template scope="scope">
                    <!--<el-button-group>-->
                        <el-button size="small" type="info" @click="editSpecial(scope.$index,scope.row)">编辑</el-button>
                        <el-button v-if="scope.row.isShowDes === 0" size="small" type="success" @click="openDesc(scope.row.specialId)">开启描述</el-button>
                        <el-button v-if="scope.row.isShowDes === 1" size="small" type="danger" @click="closeDesc(scope.row.specialId)">关闭描述</el-button>
                        <el-button v-if="scope.row.online === 0" size="small" type="success" @click="online(scope.row.specialId)">上线</el-button>
                        <el-button v-if="scope.row.online === 1" size="small" type="danger" @click="offline(scope.row.specialId)">下线</el-button>
                        <el-button size="small" @click="previewSpecialProject(scope.row.specialId)">公众号</el-button>
                    <!--</el-button-group>-->
                </template>
            </el-table-column>
        </el-table>
        <!--分页器-->
        <el-pagination class="page-control" layout="prev, pager, next" :total="specialListLength" @current-change="changePage"></el-pagination>
        <!--end-->
        <!--编辑弹框-->
        <el-dialog title="编辑-市场专题" v-model="dialogFormVisible" :modal-append-to-body="false" :close-on-click-modal="false">
            <el-form :model="editSpecialForm" :rules="validateRules" ref="editSpecialForm" label-width="100px">
                <el-form-item label="专题名称" prop="specialName">
                    <el-input v-model="editSpecialForm.specialName" auto-complete="off" placeholder="请输入专题名称"></el-input>
                </el-form-item>
                <el-form-item label="投放公司" prop="company">
                    <el-input v-model="editSpecialForm.company" auto-complete="off" placeholder="请输入焦点图地址"></el-input>
                </el-form-item>
                <el-form-item label="焦点图" prop="focusImgUrl">
                    <el-input v-model="editSpecialForm.focusImgUrl" auto-complete="off" placeholder="请输入焦点图地址"></el-input>
                </el-form-item>
                <el-form-item label="描述" prop="specialContent">
                    <el-input v-model="editSpecialForm.specialContent" auto-complete="off" placeholder="请输入专题描述（选填）"></el-input>
                </el-form-item>
                <el-form-item label="开启分享" prop="isShare">
                    <el-switch v-model="editSpecialForm.isShare" on-value="1" off-value="0">
                    </el-switch>
                </el-form-item>
                <template v-if="Number(editSpecialForm.isShare)">
                    <el-form-item label="分享链接" prop="shareUrl">
                        <el-input v-model="editSpecialForm.shareUrl" auto-complete="off" placeholder="请输入分享链接（选填）"></el-input>
                    </el-form-item>
                    <el-form-item label="分享图（尺寸200*200）" prop="shareImgUrl">
                        <el-input v-model="editSpecialForm.shareImgUrl" auto-complete="off" placeholder="请输入分享图地址"></el-input>
                    </el-form-item>
                    <el-form-item label="分享标题" prop="shareTitle">
                        <el-input v-model="editSpecialForm.shareTitle" auto-complete="off" placeholder="请输入分享标题"></el-input>
                    </el-form-item>
                    <el-form-item label="分享描述" prop="shareDes">
                        <el-input v-model="editSpecialForm.shareDes" auto-complete="off" placeholder="请输入分享描述（选填）"></el-input>
                    </el-form-item>
                </template>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogFormVisible = false">取 消</el-button>
                <el-button type="primary" @click="editSubmit('editSpecialForm')">确 定</el-button>
            </div>
        </el-dialog>
        <!--end-->
    </div>
</template>
<script>
import CONFIG from "@/config/index.js";
import TOOL from '@/tool/index.js';
import router from "@/router/index.js";
import { mapGetters } from 'vuex';
export default {
    name: "businessList",
    data() {
        return {
            userList: null,
            specialList: null,
            specialListLength: 0,
            currentPage: 1,
            baseUrl: CONFIG.HOST + '/view/superSpecial/',
            editSpecialForm: {
                specialName: '',
                company: '',
                specialId: -1,
                specialContent: '',
                focusImgUrl: '',
                isShare: '0',
                shareTitle: '',
                shareDes: '',
                shareUrl: '',
                shareImgUrl: ''
            },
            editIndex: -1,
            dialogFormVisible: false,
            validateRules: {
                specialName: [
                    { required: true, message: '请填写专题标题', trigger: 'change' }
                ],
                company: [
                    { required: true, message: '请填写投放公司', trigger: 'change' }
                ],
                focusImgUrl: [
                    { required: true, message: '请填写焦点图地址', trigger: 'change' }
                ],
                shareTitle: [
                    { required: true, message: '请填写分享标题', trigger: 'change' }
                ],
                shareImgUrl: [
                    { required: true, message: '请填写分享图片地址', trigger: 'change' }
                ]
            }
        };
    },
    mounted() {
        this._init();
    },
    computed: {
        ...mapGetters({
            userInfo: 'getUserInfo'
        })
    },
    methods: {
        _getUserList() {
            this.$http.get(CONFIG.HOST + "/users/list" + '?t=' + TOOL.getCurrentTime()).then((response) => {
                let result = response.body;
                if (result && result.status === 1) {
                    this.userList = result.data;
                } else {
                    this.$notify.error({
                        message: result.message
                    });
                }
            }, (response) => {
                console.log(response);
            });
        },
        _getSpecialListCount() {
            this.$http.get(CONFIG.HOST + "/superSpecial/listPaging/1" + "?t=" + TOOL.getCurrentTime()).then((response) => {
                let result = response.body;
                if (result && result.status === 1) {
                    this.specialListLength = result.data.totalCounts[0].counts || 0;
                } else {
                    this.$notify.error({
                        message: result.message
                    });
                }
            }, (response) => {
                console.log(response);
            });
        },
        _getSpecialPageList(pageId = 1) {
            this.$http.get(CONFIG.HOST + '/superSpecial/listPaging/' + pageId + '?t=' + TOOL.getCurrentTime()).then((response) => {
                let result = response.body;
                if (result && result.status === 1) {
                    this.specialList = result.data.listPaging;
                } else {
                    this.$notify.error({
                        message: result.message
                    });
                }
            }, (response) => {
                console.log(response);
            });
        },
        _confirmMessage(message, success = () => { }, cancel = () => { }) {
            this.$confirm(message, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(success).catch(cancel);
        },
        //编辑专题
        editSpecial(index, row) {
            this.dialogFormVisible = true;
            Object.assign(this.editSpecialForm, row);
            this.editSpecialForm.isShare = String(row.isShare);
            this.editIndex = index;
        },
        //编辑专题提交
        editSubmit(formName) {
            let flag = true;
            this.$refs[formName].validate((valid) => {
                if (!valid) {
                    flag = false;
                    return false;
                }
            });
            if (!flag) {
                this.$notify.error({
                    message: '请检查要修改的数据'
                });
                return;
            }
            this.editSpecialForm.isShare = Number(this.editSpecialForm.isShare); 
            this.$http.put(CONFIG.HOST + '/superSpecial/update', this.editSpecialForm).then((response) => {
                let result = response.body;
                if (result && result.status === 1) {
                    Object.assign(this.specialList[this.editIndex], this.editSpecialForm);
                    this.$notify.success({
                        message: '【营销平台】市场专题修改成功'
                    });
                } else {
                    this.$notify.error({
                        message: result.message
                    });
                }
            }, (response) => {
                console.log(response);
            });
        },
        //开启描述
        openDesc(specialId = -1) {
            this.$http.put(CONFIG.HOST + '/superSpecial/switchDescribe/' + specialId, { type: 1 }).then((response) => {
                let result = response.body;
                if (result && result.status === 1) {
                    this.$notify.success({
                        message: '【营销平台】成功开启专题描述'
                    });
                    this._getSpecialPageList(this.currentPage);
                } else {
                    this.$notify.success({
                        message: result.message
                    });
                }
            }, (response) => {
                console.log(response);
            });
        },
        //关闭描述
        closeDesc(specialId = -1) {
            this.$http.put(CONFIG.HOST + '/superSpecial/switchDescribe/' + specialId, { type: 0 }).then((response) => {
                let result = response.body;
                if (result && result.status === 1) {
                    this.$notify.success({
                        message: '【营销平台】成功关闭专题描述'
                    });
                    this._getSpecialPageList(this.currentPage);
                } else {
                    this.$notify.success({
                        message: result.message
                    });
                }
            }, (response) => {
                console.log(response);
            });
        },
        //上线专题
        online(specialId = -1) {
            this.$http.put(CONFIG.HOST + '/superSpecial/switchLine/' + specialId, { type: 1 }).then((response) => {
                let result = response.body;
                if (result && result.status === 1) {
                    this.$notify.success({
                        message: '【营销平台】成功上线专题'
                    });
                    this._getSpecialPageList(this.currentPage);
                } else {
                    this.$notify.success({
                        message: result.message
                    });
                }
            }, (response) => {
                console.log(response);
            });
        },
        //下线专题
        offline(specialId = -1) {
            this.$http.put(CONFIG.HOST + '/superSpecial/switchLine/' + specialId, { type: 0 }).then((response) => {
                let result = response.body;
                if (result && result.status === 1) {
                    this.$notify.success({
                        message: '【营销平台】成功下线专题'
                    });
                    this._getSpecialPageList(this.currentPage);
                } else {
                    this.$notify.success({
                        message: result.message
                    });
                }
            }, (response) => {
                console.log(response);
            });
        },
        //公众号
        previewSpecialProject(specialId) {
            window.open('http://top.yidianzixun.com/view/superSpecialTab/' + specialId);
        },
        //分页
        changePage(page) {
            this.currentPage = page;
            this._getSpecialPageList(page);
        },
        _init() {
            this._getSpecialListCount();
            this._getSpecialPageList();
            this._getUserList();
        }
    }
};
</script>
<style lang="less">
.marketList {
    width: 98%;
    margin: 0 auto;
    .bread-nav {
        margin: 20px 0;
    }
    .market-list-table {
        min-width: 980px;
        .el-table__body-wrapper{
            overflow: hidden;
        }
    }
    .page-control {
        margin: 20px auto 0 auto;
    }
    .selectForm {
        width: 100%;
    }
    .el-switch {
        position: absolute;
        left: 0;
        top: 7px;
    }
    .el-form-item__label {
        font-weight: bold;
    }
}
</style>




// WEBPACK FOOTER //
// List.vue?bdbc0bbc